var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import config from '@/config';
import api from '@/shared/api';
import { useEffect, useState, useCallback, useMemo } from 'react';
import Axios from 'axios';
import InfiniteScroll from 'react-infinite-scroller';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
import { FormattedTime, useIntl, defineMessages } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import dateFormatService from '@/shared/services/DateFormatService';
import DataCacheService from '@/shared/services/DataCacheService';
import moment from 'moment';
import { formatListValue } from '@/shared/components/FormattedListValue';
import DocumentService from '@/shared/services/DocumentService';
import { DownloadIcon } from '@/shared/components/Icons';
import TaskStatusIcon from '@/modules/tasks/TaskStatusIcon';
var onlyUnique = function (value, index, self) { return self.indexOf(value) === index; };
var pageSize = 50;
var adminUserId = '11111111-1111-1111-1111-111111111111';
var dateFormat = 'YYYY-MM-DDTHH:mm:ssZ';
var messages = defineMessages({
    ATaskWasLinked: {
        id: 'ATaskWasLinked',
        defaultMessage: 'A task was linked to this document',
    },
    ATaskWasUnlinked: {
        id: 'ATaskWasUnlinked',
        defaultMessage: 'A task was unlinked from this document',
    },
    DocumentAuditLogsNotAvailable: {
        id: 'DocumentAuditLogsNotAvailable',
        defaultMessage: 'For technical reasons, audit logs are not available for this document because it was uploaded before october 10th 2024. Sorry for the inconvenience.',
    },
    ThisTaskWasDeleted: {
        id: 'ThisTaskWasDeleted',
        defaultMessage: 'this task was deleted',
    },
    Tasks: {
        id: 'Tasks',
        defaultMessage: 'Tasks',
    },
    AuditLog: {
        id: 'AuditLog',
        defaultMessage: 'AuditLog',
    },
    DownloadThisVersionOfTheDocument: {
        id: 'DownloadThisVersionOfTheDocument',
        defaultMessage: 'Download this version of the document',
    },
    Download: {
        id: 'Download',
        defaultMessage: 'Download',
    },
    RecognitionStatus: {
        id: 'RecognitionStatus',
        defaultMessage: 'RecognitionStatus',
    },
    Tags: {
        id: 'Tags',
        defaultMessage: 'Tags',
    },
    Relations: {
        id: 'Relations',
        defaultMessage: 'Relations',
    },
    SigningFailedReason: {
        id: 'SigningFailedReason',
        defaultMessage: 'SigningFailedReason',
    },
    Yes: {
        id: 'Yes',
        defaultMessage: 'Yes',
    },
    No: {
        id: 'No',
        defaultMessage: 'No',
    },
    IsPublicOnPortal: {
        id: 'IsPublicOnPortal',
        defaultMessage: 'IsPublicOnPortal',
    },
    SigningRequestDate: {
        id: 'SigningRequestDate',
        defaultMessage: 'SigningRequestDate',
    },
    SigningDate: {
        id: 'SigningDate',
        defaultMessage: 'SigningDate',
    },
    DocumentStartDate: {
        id: 'DocumentStartDate',
        defaultMessage: 'DocumentStartDate',
    },
    DocumentEndDate: {
        id: 'DocumentEndDate',
        defaultMessage: 'DocumentEndDate',
    },
    DocumentDate: {
        id: 'DocumentDate',
        defaultMessage: 'DocumentDate',
    },
    SetEnum: {
        id: 'SetEnum',
        defaultMessage: '{property} was set to {value}',
    },
    ClearEnum: {
        id: 'ClearEnum',
        defaultMessage: '{property} was cleared. Old value: {value}',
    },
    SigningStatus: {
        id: 'SigningStatus',
        defaultMessage: 'SigningStatus',
    },
    DocumentType: {
        id: 'DocumentType',
        defaultMessage: 'DocumentType',
    },
    Filename: {
        id: 'Filename',
        defaultMessage: 'Filename',
    },
    ChangedField: {
        id: 'ChangedField',
        defaultMessage: '{property} was changed from {originalValue} to {currentValue}',
    },
    DocumentContentModified: {
        id: 'DocumentContentModified',
        defaultMessage: 'Document content was modified',
    },
    DocumentCheckedIn: {
        id: 'DocumentCheckedOn',
        defaultMessage: 'Document content was checked in by {name}',
    },
    DocumentCheckedOut: {
        id: 'DocumentCheckedOut',
        defaultMessage: 'Document content was checked out by {name}',
    },
    DocumentCheckoutDiscarded: {
        id: 'DocumentCheckoutDiscarded',
        defaultMessage: 'Document checkout was discarded by {name}',
    },
    DocumentCreated: {
        id: 'DocumentCreated',
        defaultMessage: 'Document was created',
    },
    NoAuditLinesFound: {
        id: 'NoAuditLinesFound',
        defaultMessage: 'No audit lines found',
    },
    GenericDocumentRecognition: {
        id: 'GenericDocumentRecognition',
        defaultMessage: 'Generic document recognition',
    },
});
export var DocumentAudits = function (_a) {
    var documentId = _a.documentId, storageType = _a.storageType, creationDate = _a.creationDate;
    var intl = useIntl();
    var isDevelopment = config.environment.toLowerCase() === 'local' ||
        config.environment.toLowerCase() === 'development';
    var isAcceptance = config.environment.toLowerCase() === 'acceptance';
    var _b = useState([]), auditLines = _b[0], setAuditLines = _b[1];
    var _c = useState(false), auditLogsAvailable = _c[0], setAuditLogsAvailable = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), hasMore = _e[0], setHasMore = _e[1];
    var _f = useState([]), relationIds = _f[0], setRelationIds = _f[1];
    var _g = useState([]), taskIds = _g[0], setTaskIds = _g[1];
    var _h = useState(false), hasError = _h[0], setHasError = _h[1];
    var _j = useState({}), usersDictionary = _j[0], setUsersDictionary = _j[1];
    var _k = useState({}), relationsDictionary = _k[0], setRelationsDictionary = _k[1];
    var _l = useState({}), tasksDictionary = _l[0], setTasksDictionary = _l[1];
    var _m = useState(null), parentRef = _m[0], setParentRef = _m[1];
    useEffect(function () {
        var auditLogsReleaseDate = isDevelopment
            ? moment('20-09-2024', 'DD-MM-YYYY')
            : isAcceptance
                ? moment('03-10-2024', 'DD-MM-YYYY')
                : moment('10-10-2024', 'DD-MM-YYYY');
        var internalAuditLogsAvailable = moment
            .utc(creationDate)
            .startOf('day')
            .isSameOrAfter(auditLogsReleaseDate.startOf('day'));
        // re-load audits when the document has changed
        setAuditLogsAvailable(internalAuditLogsAvailable);
        setLoading(false);
        setHasError(false);
        setAuditLines([]);
        if (internalAuditLogsAvailable) {
            setHasMore(true);
        }
    }, [documentId, isDevelopment, isAcceptance, creationDate]);
    useEffect(function () {
        var newUsersDictionary = DataCacheService.getAllUsers().reduce(function (prev, current) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[current.id] = current.name, _a)));
        }, {});
        setUsersDictionary(newUsersDictionary);
    }, []);
    useEffect(function () {
        if (relationIds.length === 0)
            return;
        var uri = "".concat(config.appUrls.api, "/api/Relation/Names");
        var fetchRelations = function () {
            api.base.post(uri, relationIds).then(function (_a) {
                var data = _a.data;
                var newRelationsDictionary = data.reduce(function (prev, current) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[current.id] = "".concat(current.name, " ").concat(current.firstName ? current.firstName : ''), _a)));
                }, {});
                setRelationsDictionary(function (current) { return (__assign(__assign({}, (current || {})), newRelationsDictionary)); });
            });
        };
        fetchRelations();
    }, [relationIds, intl]);
    useEffect(function () {
        if (taskIds.length === 0)
            return;
        var uri = "".concat(config.appUrls.tasks, "/api/plannedtasks/tasks");
        var fetchTasks = function () {
            api.base.post(uri, taskIds).then(function (_a) {
                var data = _a.data;
                var newTasksDictionary = data.reduce(function (prev, current) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[current.id] = current, _a)));
                }, {});
                setTasksDictionary(function (current) { return (__assign(__assign({}, (current || {})), newTasksDictionary)); });
            });
        };
        fetchTasks();
    }, [taskIds, intl]);
    var loadNextPage = useCallback(function (page) {
        var cancelToken = Axios.CancelToken.source();
        var uri = "".concat(config.appUrls.audit, "/api/Documents/").concat(documentId, "?limit=").concat(pageSize, "&offset=").concat(page * pageSize);
        setLoading(true);
        return api.base.get(uri, { cancelToken: cancelToken.token }).then(function (_a) {
            var data = _a.data;
            var reducedData = data.map(function (logLine) { return (__assign(__assign({}, logLine), { id: logLine.dateTime, dateTime: new Date(logLine.dateTime), type: logLine.type.toLowerCase() })); });
            if (data.length < pageSize)
                setHasMore(false);
            setAuditLines(__spreadArray(__spreadArray([], auditLines, true), reducedData, true));
            var allRelationIds = reducedData
                .reduce(function (result, logLine) {
                if (logLine.type.toLowerCase() === 'field' &&
                    logLine.property &&
                    logLine.property.toLowerCase() === 'relationids') {
                    var newSplitRelationIds = logLine.newValue
                        ? logLine.newValue.split(',').map(function (x) { return x.trim(); })
                        : [];
                    var oldSplitRelationIds = logLine.oldValue
                        ? logLine.oldValue.split(',').map(function (x) { return x.trim(); })
                        : [];
                    newSplitRelationIds.forEach(function (x) {
                        result.push(x);
                    });
                    oldSplitRelationIds.forEach(function (x) {
                        result.push(x);
                    });
                }
                return result;
            }, [])
                .filter(function (x) { return x !== null && typeof x !== 'undefined'; })
                .filter(onlyUnique);
            setRelationIds(allRelationIds);
            var allTaskIds = reducedData
                .reduce(function (result, logLine) {
                if (logLine.type.toLowerCase() === 'field' &&
                    logLine.property &&
                    logLine.property.toLowerCase() === 'taskids') {
                    var newSplitTaskIds = logLine.newValue
                        ? logLine.newValue.split(',').map(function (x) { return x.trim(); })
                        : [];
                    var oldSplitTaskIds = logLine.oldValue
                        ? logLine.oldValue.split(',').map(function (x) { return x.trim(); })
                        : [];
                    newSplitTaskIds.forEach(function (x) {
                        result.push(x);
                    });
                    oldSplitTaskIds.forEach(function (x) {
                        result.push(x);
                    });
                }
                return result;
            }, [])
                .filter(function (x) { return x !== null && typeof x !== 'undefined'; })
                .filter(onlyUnique);
            setTaskIds(allTaskIds);
            setLoading(false);
            return reducedData;
        }, function (error) {
            setLoading(false);
            setHasError(true);
            ToastrService.generalError(intl);
            throw error;
        });
    }, [documentId, auditLines, intl]);
    var groupedLogs = useMemo(function () {
        if (!auditLines || auditLines.length === 0)
            return [];
        return Object.values(auditLines.reduce(function (groups, log) {
            var groupKey = dateFormatService.formatDate(log.dateTime);
            if (!groups[groupKey])
                // eslint-disable-next-line no-param-reassign
                groups[groupKey] = {
                    key: groupKey,
                    label: moment(log.dateTime).format('LL'),
                    logs: [],
                };
            groups[groupKey].logs.push(log);
            return groups;
        }, {}));
    }, [auditLines]);
    var renderSource = function (source, documentType) {
        if (!source || source === 'Unknown' || source === 'Manual' || source === 0 || source === 1)
            return null;
        var sourceFormatted = function () {
            if (Number.isInteger(source)) {
                return formatListValue({ id: source, list: 'entitysourcetype', intl: intl });
            }
            if (source === 'GenericDocumentRecognition' && documentType) {
                return "".concat(intl.formatMessage(messages.GenericDocumentRecognition), " (").concat(formatListValue({
                    id: documentType,
                    list: 'documenttype',
                    intl: intl,
                }), ")");
            }
            return source in messages ? intl.formatMessage(messages[source]) : source;
        };
        return (_jsxs("span", { children: [' ', "via ", _jsx("b", { children: sourceFormatted() })] }));
    };
    var parseDate = function (value) {
        try {
            var mom = moment(value, dateFormat, true);
            if (!mom.isValid())
                return null;
            return dateFormatService.formatDate(mom);
        }
        catch (_) {
            return null;
        }
    };
    var parseBoolean = function (value) {
        switch (value) {
            case true:
            case 'True':
            case 'true':
                return true;
            case false:
            case 'False':
            case 'false':
                return false;
            default:
                return null;
        }
    };
    var translatedFieldChange = function (property, originalValue, currentValue) {
        return intl.formatMessage(messages.ChangedField, {
            property: property,
            originalValue: originalValue || '/',
            currentValue: currentValue || '/',
            b: function (value) { return _jsx("b", __assign({ className: "dark" }, { children: value })); },
            i: function (value) { return _jsx("i", __assign({ className: "dark" }, { children: value })); },
        });
    };
    var translatedEnumChange = function (translatedEnumType, enumType, oldValue, newValue) {
        if (!oldValue) {
            return intl.formatMessage(messages.SetEnum, {
                property: translatedEnumType,
                value: formatListValue({ id: newValue, list: enumType, intl: intl }),
                b: function (value) { return _jsx("b", __assign({ className: "dark" }, { children: value })); },
                i: function (value) { return _jsx("i", __assign({ className: "dark" }, { children: value })); },
            });
        }
        if (!newValue) {
            console.log('cleared', oldValue);
            return intl.formatMessage(messages.ClearEnum, {
                property: translatedEnumType,
                value: formatListValue({ id: oldValue, list: enumType, intl: intl }),
                b: function (value) { return _jsx("b", __assign({ className: "dark" }, { children: value })); },
                i: function (value) { return _jsx("i", __assign({ className: "dark" }, { children: value })); },
            });
        }
        return intl.formatMessage(messages.ChangedField, {
            property: translatedEnumType,
            originalValue: formatListValue({
                id: oldValue,
                list: enumType,
                intl: intl,
            }),
            currentValue: formatListValue({
                id: newValue,
                list: enumType,
                intl: intl,
            }),
            b: function (value) { return _jsx("b", __assign({ className: "dark" }, { children: value })); },
            i: function (value) { return _jsx("i", __assign({ className: "dark" }, { children: value })); },
        });
    };
    var renderEnumChange = function (log, enumType) {
        var _a, _b;
        if (enumType.toLowerCase() === 'documenttype') {
            return (_jsx("span", { children: translatedEnumChange(intl.formatMessage(messages.DocumentType), enumType, (_a = log.oldValue) === null || _a === void 0 ? void 0 : _a.Value, (_b = log.newValue) === null || _b === void 0 ? void 0 : _b.Value) }));
        }
        if (enumType.toLowerCase() === 'signingstatus') {
            return (_jsx("span", { children: translatedEnumChange(intl.formatMessage(messages.SigningStatus), enumType, log.oldValue, log.newValue) }));
        }
        if (enumType.toLowerCase() === 'recognitionstatus') {
            return (_jsx("span", { children: translatedEnumChange(intl.formatMessage(messages.RecognitionStatus), enumType, log.oldValue, log.newValue) }));
        }
        return _jsxs("span", { children: ["Unmapped enum change: ", log.property] });
    };
    var parseRelations = function (relations) {
        return relations
            ? relations
                .split(',')
                .map(function (x) { return x.trim(); })
                .map(function (x) {
                if (x in (relationsDictionary || {}))
                    return relationsDictionary[x];
                return null;
            })
                .join(', ')
            : '/';
    };
    var getTaskName = function (task) {
        var taskName = task.name
            ? task.name
            : formatListValue({
                id: task.templateId,
                list: 'tasktemplate',
                intl: intl,
                fallback: task.name || task.templateName || task.templateId,
            });
        var taskDeadline = task.deadline ? dateFormatService.formatDate(task.deadline) : null;
        return taskDeadline ? (_jsxs("b", __assign({ className: "dark" }, { children: [taskName, " (", taskDeadline, ")"] }))) : (_jsx("b", __assign({ className: "dark" }, { children: taskName })));
    };
    var renderSingleTask = function (taskId) {
        if (taskId in (tasksDictionary || {})) {
            var task = tasksDictionary[taskId];
            return (_jsxs(_Fragment, { children: [_jsx(TaskStatusIcon, { status: task.status, isBlocked: task.isBlocked, inapplicable: task.inapplicable, rejected: task.rejected, small: true, className: "margin5R" }), getTaskName(task)] }));
        }
        return (_jsxs("span", __assign({ className: "italic" }, { children: [intl.formatMessage(messages.ThisTaskWasDeleted), ' ', _jsxs("span", __assign({ style: { color: 'white' } }, { children: ["(id: ", taskId, ")"] }))] })));
    };
    var renderTasksChange = function (log) {
        var newTasks = log.newValue ? log.newValue.split(',').map(function (x) { return x.trim(); }) : [];
        var oldTasks = log.oldValue ? log.oldValue.split(',').map(function (x) { return x.trim(); }) : [];
        var addedTasks = newTasks.filter(function (task) { return !oldTasks.includes(task); });
        var deletedTasks = oldTasks.filter(function (task) { return !newTasks.includes(task); });
        if (addedTasks.length > 0) {
            return (_jsxs("span", { children: [intl.formatMessage(messages.ATaskWasLinked), ": ", addedTasks.map(function (x) { return renderSingleTask(x); })] }));
        }
        if (deletedTasks.length > 0) {
            return (_jsxs("span", { children: [intl.formatMessage(messages.ATaskWasUnlinked), ":", ' ', deletedTasks.map(function (x) { return renderSingleTask(x); })] }));
        }
        return '/';
    };
    var renderFieldChange = function (log, property) {
        switch (property.toLowerCase()) {
            case 'filename':
                return translatedFieldChange(intl.formatMessage(messages.Filename), log.oldValue, log.newValue);
            case 'ispubliconportal':
                return translatedFieldChange(intl.formatMessage(messages.IsPublicOnPortal), parseBoolean(log.oldValue)
                    ? intl.formatMessage(messages.Yes)
                    : intl.formatMessage(messages.No), parseBoolean(log.newValue)
                    ? intl.formatMessage(messages.Yes)
                    : intl.formatMessage(messages.No));
            case 'documentdate':
                return translatedFieldChange(intl.formatMessage(messages.DocumentDate), parseDate(log.oldValue), parseDate(log.newValue));
            case 'relationids':
                return translatedFieldChange(intl.formatMessage(messages.Relations), parseRelations(log.oldValue), parseRelations(log.newValue));
            case 'taskids':
                return renderTasksChange(log);
            case 'tags':
                return translatedFieldChange(intl.formatMessage(messages.Tags), log.oldValue, log.newValue);
            case 'documentstartdate':
                return translatedFieldChange(intl.formatMessage(messages.DocumentStartDate), parseDate(log.oldValue), parseDate(log.newValue));
            case 'documentenddate':
                return translatedFieldChange(intl.formatMessage(messages.DocumentEndDate), parseDate(log.oldValue), parseDate(log.newValue));
            case 'signingdate':
                return translatedFieldChange(intl.formatMessage(messages.SigningDate), parseDate(log.oldValue), parseDate(log.newValue));
            case 'signingrequestdate':
                return translatedFieldChange(intl.formatMessage(messages.SigningRequestDate), parseDate(log.oldValue), parseDate(log.newValue));
            case 'signingstatus':
                return renderEnumChange(log, property);
            case 'recognitionstatus':
                return renderEnumChange(log, property);
            case 'signingfailedreason':
                return translatedFieldChange(intl.formatMessage(messages.SigningFailedReason), log.oldValue, log.newValue);
            default:
                return _jsxs("span", { children: ["Unmapped property: ", property] });
        }
    };
    var downloadVersion = function (blobVersionId, filename, mimeType) {
        if (storageType === 1)
            return null; // currently not able to retrieve/download specific version of a file located in sharepoint
        return (_jsx("a", __assign({ style: { verticalAlign: 'middle', marginLeft: '5px' }, title: intl.formatMessage(messages.DownloadThisVersionOfTheDocument), onClick: function () { return DocumentService.download(documentId, blobVersionId, filename, mimeType); } }, { children: _jsx(DownloadIcon, {}) })));
    };
    var renderLogLine = function (log) {
        var type = log.type, property = log.property;
        switch (type.toLowerCase()) {
            case 'entitycreated':
                return (_jsxs("span", { children: [intl.formatMessage(messages.DocumentCreated), log.blobVersionId
                            ? downloadVersion(log.blobVersionId, log.fileName, log.mimeType)
                            : null] }));
            case 'documentcontentmodified':
                return (_jsxs("span", { children: [intl.formatMessage(messages.DocumentContentModified), log.blobVersionId
                            ? downloadVersion(log.blobVersionId, log.fileName, log.mimeType)
                            : null] }));
            case 'documentcheckedout':
                return (_jsx("span", { children: intl.formatMessage(messages.DocumentCheckedOut, {
                        name: DataCacheService.getUserName(log.userId),
                    }) }));
            case 'documentcheckedin':
                return (_jsxs("span", { children: [intl.formatMessage(messages.DocumentCheckedIn, {
                            name: DataCacheService.getUserName(log.userId),
                        }), log.blobVersionId
                            ? downloadVersion(log.blobVersionId, log.fileName, log.mimeType)
                            : null] }));
            case 'documentcheckoutdiscarded':
                return (_jsx("span", { children: intl.formatMessage(messages.DocumentCheckoutDiscarded, {
                        name: DataCacheService.getUserName(log.userId),
                    }) }));
            case 'field':
                return renderFieldChange(log, property);
            case 'enum':
                return renderEnumChange(log, property);
            default:
                return _jsxs("span", { children: ["Unmapped log type: ", type] });
        }
    };
    var renderLogs = function (logs) {
        if (!logs)
            return _jsx("div", {});
        return logs.map(function (logLine) { return (_jsxs("li", __assign({ className: "document-audit-container-item list-group-item" }, { children: [_jsx("div", __assign({ className: "log" }, { children: renderLogLine(logLine) })), _jsxs("div", __assign({ className: "info" }, { children: [_jsx(FormattedTime, { value: logLine.dateTime }), logLine.userId === adminUserId ? _jsx("span", __assign({ className: "name" }, { children: "AdminPulse" })) : null, usersDictionary[logLine.userId] && (_jsx("span", __assign({ className: "name" }, { children: usersDictionary[logLine.userId] }))), renderSource(logLine.source, logLine.documentType)] }))] }))); });
    };
    var renderGroups = function () {
        if (!groupedLogs || groupedLogs.length === 0)
            return loading ? null : intl.formatMessage(messages.NoAuditLinesFound);
        return groupedLogs
            .filter(function (x) { return x !== null; })
            .map(function (_a) {
            var label = _a.label, logs = _a.logs;
            return (_jsxs("div", __assign({ className: "audit-group" }, { children: [_jsx("div", __assign({ className: "audit-group-label" }, { children: label })), _jsx("ul", __assign({ className: "audit-group-logs list-group" }, { children: renderLogs(logs) }))] })));
        });
    };
    return (_jsx("div", __assign({ className: "audits" }, { children: _jsx("div", __assign({ className: "document-audit-container" }, { children: _jsx("div", __assign({ className: "flex-col", ref: function (node) {
                    setParentRef(node);
                }, style: { height: '700px', overflow: 'auto' } }, { children: auditLogsAvailable ? (_jsx(InfiniteScroll, __assign({ pageStart: -1, loadMore: loadNextPage, hasMore: hasMore && !loading && !hasError, initialLoad: true, loader: _jsx(LoadingAnimation, {}), useWindow: false, getScrollParent: function () { return parentRef; } }, { children: renderGroups() }), documentId)) : (intl.formatMessage(messages.DocumentAuditLogsNotAvailable)) })) })) })));
};
